export const partijAnders = "ZZ";
export const partijLabelAnders = "Anders";
export const partijOnafhankelijk = "XX";
